import { apiClient } from '@/api/client'
import { queryKeys } from '@/api/queryKeys'

export interface Preferences {
  homePage: string | null
}

/**
 * The member's own preferences, as ONE query definition shared by everybody who
 * reads them.
 *
 * It exists because two places now issue this fetch and they must be the same
 * fetch: `HomeRedirect` renders from it, and `ProtectedRoute` warms it the moment
 * `/auth/refresh` resolves (IN-46 Phase 4.1). If the two drifted — a different
 * key, a different `staleTime` — the warm-up would populate a cache entry the
 * reader never looks at, and the round trip it exists to remove would silently
 * come back while the code still looked correct.
 */
export const preferencesQuery = {
  queryKey: queryKeys.settings.preferences,
  queryFn: async (): Promise<Preferences> => {
    const { data } = await apiClient.get('/team-members/me/preferences')
    return data
  },
  staleTime: 5 * 60 * 1000,
}
